exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* --------------- Legal --------------- */\n\n.legal .legal-info {\n\tmargin: 0 0 30px 0;\n}\n.legal .legal-info p {\n\tline-height: 1.8;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/legal/legal.component.css
// module id = ./src/app/legal/legal.component.css
// module chunks = 1